import micromatch from 'micromatch'

/**
 문자열 utility
 @packageDocumentation
 */

/**
 * 문자열의 byte를 조회
 * @param str
 */
export const byteLength = (str: string) => {
  if (!str) {
    return 0
  }

  return str
    .split('')
    .map(s => s.charCodeAt(0))
    .reduce((prev, c) => prev + (c === 10 ? 2 : c >> 7 ? 2 : 1), 0)
}

/**
 * byte 수로 문자 cut
 */
export const cutByteLength = (s, len) => {
  if (s == null || s.length === 0) {
    return 0
  }

  let size = 0
  let rIndex = s.length

  for (let i = 0; i < s.length; i++) {
    size += s.charCodeAt(i) === 10 ? 2 : s.charCodeAt(i) >> 7 ? 2 : 1
    if (size === len) {
      rIndex = i + 1
      break
    } else if (size > len) {
      rIndex = i
      break
    }
  }
  return s.substring(0, rIndex)
}

/**
 * 문자열의 패턴을 검사한다.
 * @param searchText 조회할 텍스트
 * @param patterns 패턴 목록
 * @see micromatch
 */
export const isMatchPatterns = (searchText: string, ...patterns: string[]) => {
  for (const pattern of patterns) {
    if (micromatch.isMatch(searchText, pattern)) {
      return true
    }
  }

  return false
}
